import type { PropertyResponse } from '@/shared/api';
import { AuthenticatedImage } from '../bilder/AuthenticatedImage';

/**
 * 60x80 Cover-Vorschau in der Liste — Rückfall auf eine Initialen-Fläche, wenn kein Cover
 * gesetzt ist. `AuthenticatedImage` lädt `loading="lazy"`, viele Apartments erzeugen also kein
 * Anfragen-Gewitter.
 */
export function CoverThumb({ property }: { property: PropertyResponse }) {
  if (property.coverFileId) {
    return (
      <AuthenticatedImage
        propertyId={property.id}
        fileId={property.coverFileId}
        variant="thumb"
        alt={`Titelbild ${property.name}`}
        className="border-line w-15 h-20 shrink-0 rounded-md border"
      />
    );
  }
  return (
    <div
      className="bg-card-alt border-line text-ink-soft w-15 flex h-20 shrink-0 items-center justify-center rounded-md border text-base font-medium uppercase"
      aria-hidden
    >
      {property.name.slice(0, 2)}
    </div>
  );
}
